import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- constants
import ViewConstants from 'constants/ViewConstants';

// -- entities
import Menu from 'PMT/entities/menu/Menu';

// -- views
import ImageLoader from 'PMT/components/ImageLoader';

class MenuRow extends Component {

  static propTypes = {
    menu: PropTypes.instanceOf(Menu).isRequired
  };


  shouldComponentUpdate(nextProps) {
    return !nextProps.menu.equals(this.props.menu);
  }

  onDisplayDetail = () => {
    RouteAction.presentMenuDetail(this.props.menu);
  };

  onUp = () => {

  };

  onDown = () => {

  };

  onDeleteFromCategory = () => {

  };

  render() {
    const menu:Menu = this.props.menu;

    return (
      <tr className="menu_row pointer">

        <td
          className="hidden-sm col-md-1 text-left"
          onClick={this.onDisplayDetail}
        >
          <ImageLoader
            src={menu.image}
            className="menu_row__image"
            placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_MENU}
          />
        </td>

        <td
          className="menu__name col-md-8"
          onClick={this.onDisplayDetail}
        >
          <h4>{menu.name}</h4>
        </td>

        <td
          className="pointer col-md-1 text-right"
        >
        </td>

        <td
          className="pointer col-md-1 text-center"
        >
        </td>

      </tr>
    );
  }

}

export default MenuRow;
